export default function ifPermissionOr(stripes, perms, children) {
    // ensure the user has at least one perm
    if (perms.some(function (p) { return stripes.hasPerm(p); })) {
        return children;
    }
    return null;
}
